import { Combination } from "./combination.model"

export interface PriceRange {
  min: number;
  max: number;
}

export class Slot {

  public anyCombination: Combination;
  public employees: string[];
  public hasCombinations: boolean;
  public otherCombinationsAvailable: boolean;
  public regularOfferAvailable: boolean;
  public priceRange: PriceRange;
  public start: string;
  public events: string[];
  

  constructor(
    obj?: any 
  ) {
    this.anyCombination = obj && obj.anyCombination || null;
    this.employees = obj && obj.employees || null;
    this.hasCombinations = obj && obj.hasCombinations || null;
    this.otherCombinationsAvailable = obj && obj.otherCombinationsAvailable || null;
    this.regularOfferAvailable = obj && obj.regularOfferAvailable || null;
    this.priceRange = obj && obj.priceRange || null;
    this.start = obj && obj.start || null;
    this.events = obj && obj.events || null;
  }

  

}